import React, { useCallback } from 'react'
import { LeadDetailsDto } from 'api/Leads/Types/LeadDetailsDto'
import { Loading } from 'components/Loading'
import { useFetchOne } from 'utils/api/useFetch'

import { useApiClient } from '../../../../utils/api/ApiClient'
import { LeadsApiClient } from '../../../../utils/api/leadsApi'
import { LeadVerificationsTable } from './LeadVerificationsTable'

interface Props {
  data: LeadDetailsDto
}

export const LeadVerificationsPage: React.FC<Props> = ({ data }) => {
  const leadsApiClient = useApiClient(LeadsApiClient)

  const fetchData = useCallback(async () => {
    return leadsApiClient.getLeadVerifiableActions(data.id)
  }, [data]) // eslint-disable-line react-hooks/exhaustive-deps
  const { data: leadVerifiableActions = [], isLoading } = useFetchOne(fetchData)

  return (
    <Loading isLoading={isLoading}>
      <LeadVerificationsTable leadVerifiableActions={leadVerifiableActions} />
    </Loading>
  )
}
